import * as React from 'react'
import { Container, Grid, Box, Typography, Link } from '@material-ui/core';


class ErrorPage extends React.Component {  

    handleGoToHelpCenter = () => {
        const pathUrl: string = 'https://help.wideo.co/hc/en-us';
        window.location.href = pathUrl;
      }      

    render() {
        return (
            <Container maxWidth="xs">
                <Grid container spacing={0}>  
                    <Grid item xs={12}>
                        <Box textAlign="center">
                            <img
                                alt="wideo error message"
                                src="/img/art-error.svg"
                                height="312px"
                            />                            
                            <Typography variant="h3" component="h1" color="primary" gutterBottom>
                                <Box component="span" display="block" fontWeight="fontWeightLight">Sorry!</Box>
                            </Typography>
                            <Typography variant="body1" color="textSecondary" gutterBottom>
                                <Box component="span" display="block" fontWeight="fontWeightLight" mb={3}>MediaRecorder not supported on your browser, please use the latest version of Safari, Firefox or Chrome.</Box>
                            </Typography>
                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                <Box display="block" fontWeight="fontWeightLight" mt={4}>
                                    If the problem persists &nbsp;
                                    <Link
                                        onClick={this.handleGoToHelpCenter}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        contact our support team
                                    </Link>.
                                </Box>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        );
    }
}

export default ErrorPage
